<template>
  <div class="base-settings-filters">
    <e-select v-model="filter.serviceGroupFilter" :items="serviceGroupFilterItems" label="Группа услуг" clearable />
    <e-select v-model="filter.roomCategoryFilter" :items="roomCategoryFilterItems" label="Категория номера" clearable />
    <e-select v-model="filter.placeFilter" :items="placeFilterItems" label="Место" clearable />
    <e-select v-model="filter.touristTypeFilter" :items="touristTypeFilterItems" label="Тип туриста" clearable />
  </div>
</template>

<script setup lang="ts">
import type { SimpleFilterItems } from '@/core/types/filters';
import { ESelect } from '@/core/components/ui';
import { placeFilterItems } from '@/parts/tariffs/utils/consts';

defineProps<{
  serviceGroupFilterItems: SimpleFilterItems;
  roomCategoryFilterItems: SimpleFilterItems;
  touristTypeFilterItems: string[];
}>();

const filter = defineModel<{
  serviceGroupFilter: string | null;
  roomCategoryFilter: string | null;
  placeFilter: string | null;
  touristTypeFilter: string | null;
}>({ required: true });
</script>

<style scoped lang="scss">
.base-settings-filters {
  display: flex;
  gap: 16px;

  @include sm-and-down {
    flex-direction: column;
  }
}
</style>
